import { Controller } from "@hotwired/stimulus"
import posthog from 'posthog-js'

export default class extends Controller {
  static values = {
    currentUser: { type: Object, default: undefined },
  }

  connect(){
    // Dont log events from development
    if (window.location.host.includes('127.0.0.1') || window.location.host.includes('localhost')) {
      return
    }

    posthog.init('phc_sRvS7ND2bs9hfWpmyfL2HvnNdqzVvB3eCQeFaQc9yee', {
      api_host: 'https://us.i.posthog.com',
    })

    if (this.hasCurrentUserValue && this.currentUserValue){
      const { id, email, name } = this.currentUserValue

      posthog.identify(id, {
        email: email,
        name: name,
      })
    }
  }
}